import { render, staticRenderFns } from "./dateHomeCare.vue?vue&type=template&id=c2dd5a2c"
import script from "./dateHomeCare.vue?vue&type=script&lang=js"
export * from "./dateHomeCare.vue?vue&type=script&lang=js"
import style0 from "./dateHomeCare.vue?vue&type=style&index=0&id=c2dd5a2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports